// src/App.tsx
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthenticatedPages } from "./pages/AuthenticatedPages/AuthenticatedPages";
import { useAccessToken } from "./useAccessToken";
import LoginPage from "./LoginPage/LoginPage";
import { McDesignProvider } from "@multiconsult-group/core";
import { DISABLE_AUTH } from "./flags";
import { DebugViewer } from "./Debug/DebugViewer";
import { IS_PROD } from "./config";
import RtkqPatchToast from "./components/RtkqPatchToast";
import { SharedTestPage } from "./SharedTestPage";
import { PixBimDebugPage } from "./Debug/PixBimDebugPage";
import "./releaseNotes.enhancer";
import "./DesignTab/devices/deviceapi.enhancer";
import "./DesignTab/routing/graphapi.enhancer";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { accessToken, isLoading, error } = useAccessToken();
  const location = useLocation();

  if (DISABLE_AUTH) return <>{children}</>; // bypass

  if (error) return <div>Något gick fel: {error}</div>;
  if (isLoading) return <div>Laster...</div>;
  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <McDesignProvider>
      {!IS_PROD && <RtkqPatchToast />}
      <Router>
        <Routes>
          <Route path="/debug" element={<DebugViewer />} />
          <Route path="/pixbimdebug" element={<PixBimDebugPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<div>Laddar…</div>} />
          <Route path="/auth/logout" element={<div>Utloggad</div>} />
          <Route path="/shared" element={<SharedTestPage />} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <AuthenticatedPages />
              </RequireAuth>
            }
          />
        </Routes>
      </Router>
    </McDesignProvider>
  );
}
